import { render } from "./ClaimButton.vue?vue&type=template&id=422daa48&ts=true"
import script from "./ClaimButton.vue?vue&type=script&lang=ts"
export * from "./ClaimButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__